import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { Button } from '@/components/ui/button';

interface ListPaginationProps {
  page: number;
  pageSize: number;
  totalItems: number;
  onPageChange: (nextPage: number) => void;
}

export function ListPagination({ page, pageSize, totalItems, onPageChange }: ListPaginationProps) {
  const { t } = useTranslation('common');

  if (totalItems === 0) {
    return null;
  }

  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const isFirstPage = page <= 1;
  const isLastPage = page >= totalPages;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mt-4">
      <span className="text-xs text-zoomuted">{t('pagination.summary', { count: totalItems })}</span>
      <div className="flex items-center gap-3">
        <Button
          variant="outline"
          size="icon"
          className="w-10 h-10"
          aria-label={t('pagination.previous')}
          disabled={isFirstPage}
          onClick={function goToPreviousPage() {
            onPageChange(page - 1);
          }}
        >
          <Icon name="ChevronLeft" />
        </Button>
        <span className="text-sm font-medium text-zooindigo">
          {t('pagination.pageOf', { page, total: totalPages })}
        </span>
        <Button
          variant="outline"
          size="icon"
          className="w-10 h-10"
          aria-label={t('pagination.next')}
          disabled={isLastPage}
          onClick={function goToNextPage() {
            onPageChange(page + 1);
          }}
        >
          <Icon name="ChevronRight" />
        </Button>
      </div>
    </div>
  );
}
